/**
 * Quick Buy Stock Info
 * Handles live clock and product count updates
 */
(function() {
	let lastProductUpdate = null; // Store the last product update time from GraphQL

	// Update live clock for FRAGRANTA live Stock
	function updateLiveClock() {
		const now = new Date();

	// Format date and time with seconds (for live stock)
	const dateTimeFormatter = new Intl.DateTimeFormat('en-GB', {
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: false,
		timeZone: 'Europe/Paris'
	});

		const stockDateTimeEl = document.getElementById('stockDateTime');
		if (stockDateTimeEl) {
			stockDateTimeEl.textContent = dateTimeFormatter.format(now).replace(',', '');
		}
	}

	// Fetch last updated product and total count from GraphQL
	async function fetchStockInfo() {
		const config = window.STOCK_INFO_CONFIG;
		if (!config || !config.storefrontAccessToken || !config.shop || !config.collectionHandle) {
			return null;
		}

		const query = `
      query {
        products(first: 1, sortKey: UPDATED_AT, reverse: true) {
          nodes {
            id
            title
            updatedAt
          }
        }
        collection(handle: "${config.collectionHandle}") {
          products(first: 1) {
            filters {
              id
              label
              type
              values {
                id
                label
                count
              }
            }
          }
        }
      }
    `;

		try {
			const response = await fetch(`https://${config.shop}/api/2024-01/graphql.json`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken
				},
				body: JSON.stringify({ query })
			});

			const data = await response.json();

			let result = {};

			// Get last updated product
			if (data.data && data.data.products && data.data.products.nodes.length > 0) {
				const lastProduct = data.data.products.nodes[0];
				result.lastProduct = {
					title: lastProduct.title,
					updatedAt: new Date(lastProduct.updatedAt)
				};
			}

			// Calculate total count from brand filter
			if (data.data && data.data.collection && data.data.collection.products.filters) {
				const filters = data.data.collection.products.filters;
				const brandFilter = filters.find(f => f.label === 'Product type' || f.type === 'LIST' && f.id.includes('product_type'));

				if (brandFilter && brandFilter.values) {
					const totalCount = brandFilter.values.reduce((sum, brand) => sum + brand.count, 0);
					result.totalCount = totalCount;
				}
			}

		return result;
	} catch (error) {
	}

	return null;
	}

	// Update last update time with product update info
	function updateLastUpdateTime() {
		const timeFormatter = new Intl.DateTimeFormat('en-GB', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
			timeZone: 'Europe/Paris'
		});

		const lastUpdateTimeEl = document.getElementById('lastUpdateTime');
		if (lastUpdateTimeEl && lastProductUpdate) {
			const now = new Date();
			const nowInParis = new Date(now.toLocaleString('en-GB', { timeZone: 'Europe/Paris' }));
			const updateInParis = new Date(lastProductUpdate.toLocaleString('en-GB', { timeZone: 'Europe/Paris' }));
			const isSameDay = nowInParis.toDateString() === updateInParis.toDateString();
			lastUpdateTimeEl.textContent = isSameDay
				? 'today'
				: timeFormatter.format(lastProductUpdate).replace(',', '');
		}
	}

	async function updateStockInfo() {
		// Fetch stock info (last updated product + total count) from GraphQL
		const stockInfo = await fetchStockInfo();

		if (stockInfo) {
			// Update last product time
			if (stockInfo.lastProduct) {
				lastProductUpdate = stockInfo.lastProduct.updatedAt;
			} else {
				lastProductUpdate = new Date();
			}

			// Update total count
			if (stockInfo.totalCount !== undefined) {
				window.COLLECTION_TOTAL_COUNT = stockInfo.totalCount;
				window.COLLECTION_TOTAL_COUNT_FROM_GRAPHQL = stockInfo.totalCount;
				if (typeof window.qbRenderPagination === 'function') {
					window.qbRenderPagination();
				}
			}
		} else {
			// Fallback to page load time if GraphQL fails
			lastProductUpdate = new Date();
		}

		updateLiveClock();
		updateLastUpdateTime();
		updateReferencesCount();

		// Show stock info wrapper after data is loaded
		showStockInfo();
	}

	function showStockInfo() {
		// Wait for products to be rendered before showing stock info bottom
		const checkProducts = () => {
			const productRows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
			const stockInfoBottom = document.getElementById('stockInfoBottom');

			if (productRows.length > 0 && stockInfoBottom) {
				stockInfoBottom.style.display = '';
			} else if (stockInfoBottom && window.COLLECTION_TOTAL_COUNT !== undefined) {
				// If we have total count but no products yet (maybe they're loading), wait a bit
				setTimeout(checkProducts, 100);
			} else if (stockInfoBottom) {
				// Show anyway after timeout
				setTimeout(() => {
					stockInfoBottom.style.display = '';
				}, 2000);
			}
		};

		checkProducts();
	}

	function updateReferencesCount() {
		const totalReferencesEl = document.getElementById('totalReferences');
		if (!totalReferencesEl) return;
		const productRows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');

		// Use total count from GraphQL if available
		if (window.COLLECTION_TOTAL_COUNT_FROM_GRAPHQL !== undefined) {
			totalReferencesEl.textContent = window.COLLECTION_TOTAL_COUNT_FROM_GRAPHQL;
		} else {
			// Fallback: count products in table
			const productRows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
			totalReferencesEl.textContent = productRows.length;
		}
	}

	// Update on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			updateStockInfo();
			// Start live clock - update every second
			setInterval(updateLiveClock, 1000);
		});
	} else {
		updateStockInfo();
		// Start live clock - update every second
		setInterval(updateLiveClock, 1000);
	}

	// Update references count when products change
	const observer = new MutationObserver(() => {
		updateReferencesCount();
		// Ensure stock info bottom is visible when products are rendered
		const stockInfoBottom = document.getElementById('stockInfoBottom');
		if (stockInfoBottom && stockInfoBottom.style.display === 'none') {
			showStockInfo();
		}
	});

	// Watch for product list changes
	const initObserver = () => {
		const tbody = document.querySelector('table.qb-product-table tbody');
		if (tbody) {
			observer.observe(tbody, { childList: true });
			updateReferencesCount();
		} else {
			// Try again after a delay if tbody not found yet
			setTimeout(initObserver, 1000);
		}
	};

	initObserver();

	// Watch for changes to COLLECTION_TOTAL_COUNT
	let lastTotalCount = window.COLLECTION_TOTAL_COUNT;
	setInterval(() => {
		if (window.COLLECTION_TOTAL_COUNT !== lastTotalCount) {
			lastTotalCount = window.COLLECTION_TOTAL_COUNT;
			updateReferencesCount();
		}
	}, 500);

	// Also make it globally accessible for manual updates
	window.updateStockInfo = updateStockInfo;
	window.updateReferencesCount = updateReferencesCount;
})();


